'use client';

import { useAppDispatch, useAppSelector } from '@/lib/RTK/hooks';
import { baseStaticURL } from '@/lib/servies/axiosConfig';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { FaRegClock } from 'react-icons/fa6';
import { setTracking_code } from '@/lib/RTK/features/AuthSlice';
import { formatNameDoctor } from '@/constant/scripts';
import { setSelectedTurn } from '@/lib/RTK/features/AdmissionSlice';

const CheckReserve = () => {
    const { mobile, token, name } = useAppSelector((s) => s.auth_token_slice);
    const [timeLeft, setTimeLeft] = useState<number | null>(null);
    const queryClient = useQueryClient();
    const dispatch = useAppDispatch();

    const formatTime = (seconds: number) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    };

    const { data } = useQuery({
        queryKey: ['check-reserve', mobile, token],
        staleTime: 30000,
        refetchInterval: 30000,
        enabled: !!token,
        queryFn: async () => {
            try {
                const url = `${baseStaticURL}/checkReserve`;

                const response = await axios.get(url, {
                    headers: {
                        Auth: `Bearer ${token}`,
                    },
                });
                return response.data.result;
            } catch {
                throw new Error('Error fetching data');
            }
        },
    });

    useEffect(() => {
        if (data?.time_left) {
            setTimeLeft(data.time_left);
        }
        if (data?.tracking_code) {
            dispatch(setTracking_code(data.tracking_code));
        } else if (data?.message == 'نوبت رزرو شده ای وجود ندارد.') {
            dispatch(setTracking_code('noTracking'));
        }
    }, [data]);

    useEffect(() => {
        if (timeLeft === null || timeLeft <= 0) {
            queryClient.invalidateQueries({
                queryKey: ['check-reserve', mobile],
            });
            dispatch(setTracking_code(null));
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft((prev) => (prev !== null ? prev - 1 : null));
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);

    return timeLeft && timeLeft !== 0 ? (
        <Link
            onClick={() => {
                dispatch(
                    setSelectedTurn({
                        date: data?.gdate || '',
                        time: data?.time || '',
                        jalali: data?.date || '',
                        childId: '',
                    }),
                );
            }}
            href={`/doctor/${data?.doctor_id}/${formatNameDoctor(
                data?.doctor_name,
            )}/${data?.office}/continue/checkout`}
            className="bg-blue py-5 px-3 smp:!px-8 text-white flex items-start smp:!items-center gap-x-3 justify-around"
        >
            <div>
                <p className="text-base lg:!text-2xl font-semibold">
                    {name} عزیز، شما یک رزرو نوبت ناتمام برای دکتر{' '}
                    <span className="border-b border-white">
                        {data?.doctor_name}
                    </span>{' '}
                    دارید!
                </p>
            </div>
            <div className="bg-white smp:!mt-0 mt-2 w-max md:!text-base text-sm flex text-black items-center gap-1 py-1 px-1.5 smp:!px-2 rounded-2xl">
                <p className="flex items-center gap-2">
                    <p className="smp:!block hidden whitespace-nowrap">
                        تکمیل نوبت
                    </p>
                    <span className="block w-[45px] text-center whitespace-nowrap">
                        {formatTime(Number(timeLeft))}
                    </span>
                </p>
                <FaRegClock />
            </div>
        </Link>
    ) : (
        ''
    );
};

export default CheckReserve;
